/**
 * @generated SignedSource<<25a68f87256bbfe1cb96d67b36efe0d7>>
 * @relayHash 6a5d46ad0e2c74a3a4e624e32d064d41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b1eece9d1a0afba51403c9fbb24bb8e323079b7901c43b070aeac46e06cf407e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CapacityPeopleViewContentQuery } from './CapacityPeopleViewContentQuery.graphql';

import isAiImportEnabled_provider from '../../../../../../../platform/packages/capacity-planning/capacity-planning-core/src/ui/capacity-planning-core/table/common/cell/contribution-cell/../../../../../../is-ai-import-enabled.relayprovider';
import isBulkEditEnabled_provider from '../../../../../../../platform/packages/capacity-planning/capacity-planning-core/src/ui/capacity-planning-core/table/people/row/people-view-body-row/../../../../../../is-bulk-edit-enabled.relayprovider';

const node: PreloadableConcreteRequest<CapacityPeopleViewContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b1eece9d1a0afba51403c9fbb24bb8e323079b7901c43b070aeac46e06cf407e",
    "metadata": {},
    "name": "CapacityPeopleViewContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__isaiimportenabledrelayprovidertsx": isAiImportEnabled_provider,
      "__relay_internal__pv__isbulkeditenabledrelayprovidertsx": isBulkEditEnabled_provider
    }
  }
};

export default node;
